<ng-container *ngIf="isUserlogged$ | async; else login">
  <!-- <div class="cx-login-greet" *ngIf="(user$ | async) as user">
        {{ 'miniLogin.userGreeting' | cxTranslate: { name: user.name } }}
    </div> -->
  <ul class="d-flex links" *ngIf="user$ | async as user">
    <li class="upperMenu" style="font-size: 11px !important" *ngIf="currentUnit$ | async as unit">
      <b>NOMBRE DE LA EMPRESA:</b> {{ unit.accountName }}<br />
      <b>RUT DE LA EMPRESA:</b> {{ unit.accountRut }} <br />
      <b
      [ngClass]="{
        'text-success': user?.creditLineMessage?.toUpperCase() == 'ESTADO FINANCIERO ACEPTADO',
        'text-danger': user?.creditLineMessage?.toUpperCase() !== 'ESTADO FINANCIERO ACEPTADO'
      }">{{ user?.creditLineMessage}}</b>
    </li>
    <li class="">Bienvenido {{ user.firstName }}</li>
    <li class="">
      <div
        *ngIf="(isSmallScreen$ | async) == false"
        class="my-account"
        href="#"
        (click)="handleMyAccountClick()"
        [ngClass]="{ toggle: isBlue() && !isMyAccountDisabled(), 'is-disabled': isMyAccountDisabled() }"
      >
        Mi Cuenta
      </div>

      <div
        *ngIf="(isSmallScreen$ | async) == true"
        class="my-account"
        [collapse]="isMenuCollapsed()"
        [isAnimated]="true"
      >
        <a title="Cotizaciones" [routerLink]="'my-quotes'">Cotizaciones</a>
        <a title="Libreta de direcciones" [routerLink]="'my-account/address-book'">Libreta de direcciones</a>
        <a title="Carritos guardados" [routerLink]="{ cxRoute: 'savedCarts' } | cxUrl">Carritos guardados</a>
        <a title="Datos personales" routerLink="my-account/update-profile">Datos personales</a>
        <a title="Selecciona una Empresa" [routerLink]="'select-b2bunit'">Selecciona una Empresa</a>
        <a title="Historial de pedido" routerLink="my-account/orders">Historial de pedido</a>
      </div>
    </li>
    <li class="">
      <a (click)="logout()" class="logout"> Salir</a>
    </li>
  </ul>
</ng-container>

<ng-template #login>
  <a [routerLink]="{ cxRoute: 'login' } | cxUrl" class="login">
    {{ 'miniLogin.signInRegister' | cxTranslate }}
  </a>
</ng-template>